import * as UiReact from 'tinybase/ui-react/with-schemas';

import type { GlobalStoreSchemas, UserStoreSchemas } from '~/common/types/tinybase';

// `tinybase/ui-react/with-schemas` exports hooks/components generically; the
// documented way to get schema-typed versions is to cast the whole module to
// `WithSchemas<Schemas>` once per store schema and use those instances (one per
// store, below).

export const UiReactGlobal = UiReact as unknown as UiReact.WithSchemas<GlobalStoreSchemas>;

export const UiReactUser = UiReact as unknown as UiReact.WithSchemas<UserStoreSchemas>;
